// Card #3377 -- the preview poll cadences, split out of ModePreview.jsx so a host
// that lazy-loads the preview (Score Admin's dashboard) can read them without
// importing the whole scoreboard tree eagerly.
export const NEXT_POLL_INTERVAL_MS = 3000;
// Decided 2026-10-09 (#3304): #1907's watermark cache keeps the extra reads cheap.
export const TILE_POLL_INTERVAL_MS = 10000;
